module.exports = "/_next/static/images/CollectionLibraries@2x-e1f95ed5624f714f0c363e2c4ec6049c.png";